export const GLOBAL_SEARCH_TAG_TYPE = 'GlobalSearch' as const;
